import React, { useEffect, useState } from "react";
import SignaturePad from "./SignaturePad";
import checkmark from "../../assets/images/checkmark.svg";

export default function CheckboxForm({
  handleInputChange,
  disclosures,
  setAllChecked,
  signature,
}) {
  const [checkedItems, setCheckedItems] = useState({});

  useEffect(() => {
    const checkboxDisclosures = disclosures.filter((item) => item.checkbox);
    const initialCheckedState = checkboxDisclosures.reduce((acc, item) => {
      acc[item.sort] = false;
      return acc;
    }, {});
    setCheckedItems(initialCheckedState);
  }, [disclosures]);

  useEffect(() => {
    const allCheckboxesChecked = Object.values(checkedItems).every(Boolean);
    const signatureProvided = signature?.length > 0;
    const signatureRequired = disclosures.some((item) => item.signatureBox);

    const allChecked =
      allCheckboxesChecked && (!signatureRequired || signatureProvided);
    setAllChecked(allChecked);
  }, [checkedItems, signature, disclosures]);

  const handleCheckboxChange = (sort) => {
    setCheckedItems((prevState) => ({
      ...prevState,
      [sort]: !prevState[sort],
    }));
  };

  const renderDisclosureItem = (item) => {
    if (!item.checkbox && !item.signatureBox) {
      return (
        <div
          key={item.sort}
          className={`my-2 ${item.boldText ? "fw-bold" : ""}`}
        >
          {item.text}
        </div>
      );
    } else if (item.checkbox) {
      return (
        <div
          key={item.sort}
          className="d-flex flex-row gap-2 my-2"
          onClick={() => handleCheckboxChange(item.sort)}
        >
          <div className="col-sm-1 col-2">
            <div
              className={
                checkedItems[item.sort] ? "checkBox checked" : "checkBox"
              }
            >
              <img src={checkmark} alt="checkmark" />
            </div>
          </div>
          <div className={item.boldText ? "fw-bold" : ""}>{item.text}</div>
        </div>
      );
    } else {
      return (
        <div key={item.sort} className="text-center">
          <div className={item.boldText ? "fw-bold" : ""}>{item.text}</div>
          <SignaturePad handleInputChange={handleInputChange} />
        </div>
      );
    }
  };

  return (
    <div className="text-small">
      {disclosures.sort((a, b) => a.sort - b.sort).map(renderDisclosureItem)}
    </div>
  );
}
